import { EditorState } from 'prosemirror-state';

const URL_PROTOCOL_REGEX = /^http[s]?:\/\//;
const URL_PROTOCOL_PREFIX = 'http://';

export function adaptHref(href: string) {
  if (href.search(URL_PROTOCOL_REGEX) === -1) {
    return `${URL_PROTOCOL_PREFIX}${href}`;
  }
  return href;
}

export function isEmptySelection(state: EditorState) {
  const $head = state.selection.$head;
  for (let d = $head.depth; d > 0; d--) {
    if (!$head.node(d).content.size) {
      return true;
    }
  }

  return false;
}
